// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35EZp","questions":"styles_questions__16FaZ","footer":"styles_footer__2i81n"};